import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import axios from "axios";
import TagsInput from "react-tagsinput";
import Select from "react-select";
import appConfig from "../../config/appConfig";
import InfoFormatExcel from "../../constants/InfoFormatExcel";
import { filterChannel, formatSelectOption, formatToTimeStamp, resolveComponentLocale, localize } from "../../helpers/function";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { RESPONSE_CHANNEL } from "../../constants/channel";
import { ToastBottomEnd } from "../components/Toast";
import {
  toastAddErrorMessageConfig,
  toastAddSuccessMessageConfig,
  toastErrorMessageWithParameterConfig,
} from "../../config/toastConfig";
import ConfirmClaimAddModal from "../components/Modal/ConfirmClaimAddModal";
import InfirmationTable from "../components/InfirmationTable";
import InputRequire from "../components/InputRequire";
import WithoutCode from "../components/WithoutCode";
import Loader from "../components/Loader";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import WithCode from "../components/WithCode";

const MySwal = withReactContent(Swal);

const ClaimAdd = (props) => {
  // Start config

  const defaultData = {
    firstname: "",
    lastname: "",
    sexe: "",
    telephone: [],
    email: [],
    ville: "",
    raison_sociale: "",
    type_client: "",
    lieu: "",
    unit_targeted_id: "",
    institution_targeted_id: "",
    account_targeted_id: "",
    account_number: "",
    relationship_id: "",
    claim_object_id: "",
    request_channel_slug: "",
    response_channel_slug: "",
    messenger_number: "",
    linkedin_number: "",
    whatsapp_number: "",
    postal_address: "",
    claimer_expectation: "",
    description: "",
    amount_currency_slug: "",
    amount_disputed: "",
    claimer_id: "",
    event_occured_at: "",
    is_revival: 0,
    received_at: "",
    prepaid_card_number: "",
    send_mail: 1,
    file: [],
  };

  const [data, setData] = useState(defaultData);

  const endPointConfig = {
    PRO: {
      plan: "PRO",
      create: `${appConfig.apiDomaine}/my/claims/create`,
      store:
        data?.type_client == "Physique"
          ? `${appConfig.apiDomaine}/my/claims`
          : `${appConfig.apiDomaine}/my/claims/moral-entity`,
      storeKnowingIdentity: (id) =>
        `${appConfig.apiDomaine}/my/identites/${id}/claims`,
    },
    MACRO: {
      holding: {
        create: `${appConfig.apiDomaine}/any/claims/create`,
        store:
          data?.type_client == "Physique"
            ? `${appConfig.apiDomaine}/any/claims`
            : `${appConfig.apiDomaine}/any/claims/moral-entity`,
        storeKnowingIdentity: (id) =>
          `${appConfig.apiDomaine}/any/identites/${id}/claims`,
      },
      filial: {
        create: `${appConfig.apiDomaine}/my/claims/create`,
        store:
          data?.type_client == "Physique"
            ? `${appConfig.apiDomaine}/my/claims`
            : `${appConfig.apiDomaine}/my/claims/moral-entity`,
        storeKnowingIdentity: (id) =>
          `${appConfig.apiDomaine}/my/identites/${id}/claims`,
      },
    },
    HUB: {
      plan: "HUB",
      create: `${appConfig.apiDomaine}/without-client/claims/create`,
      store: `${appConfig.apiDomaine}/without-client/claims`,
      storeKnowingIdentity: (id) =>
        `${appConfig.apiDomaine}/without-client/identites/${id}/claims`,
    },
  };

  const downloadReceipt = async (claim_id) => {
    const institutionPrintReceiptEndpoint = `${appConfig.apiDomaine}/download-claim-receipt`;    
    if(verifyTokenExpire()) {
      setLoad(true);
      await axios.get(`${institutionPrintReceiptEndpoint}/${claim_id}`, {
        responseType: 'blob'
      }).then((response) => {
        const fileURL = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a',);
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'receipt.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        setLoad(false);
      })
   }
  };

  // End config
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title =
    "Satis client - " + ready ? t("Enregistrement de réclamation") : "";
  if (
    !(
      verifyPermission(
        props.userPermissions,
        "store-claim-against-any-institution"
      ) ||
      verifyPermission(
        props.userPermissions,
        "store-claim-against-my-institution"
      ) ||
      verifyPermission(props.userPermissions, "store-claim-without-client")
    )
  )
    window.location.href = ERROR_401;

  let endPoint = "";
  if (props.plan === "MACRO") {
    if (
      verifyPermission(
        props.userPermissions,
        "store-claim-against-any-institution"
      )
    )
      endPoint = endPointConfig[props.plan].holding;
    else if (
      verifyPermission(
        props.userPermissions,
        "store-claim-against-my-institution"
      )
    )
      endPoint = endPointConfig[props.plan].filial;
  } else endPoint = endPointConfig[props.plan];

  const defaultError = {
    firstname: [],
    lastname: [],
    sexe: [],
    telephone: [],
    email: [],
    ville: [],
    raison_sociale: [],
    type_client: [],
    lieu: [],
    unit_targeted_id: [],
    institution_targeted_id: [],
    relationship_id: [],
    account_targeted_id: [],
    account_number: [],
    claim_object_id: [],
    claim_category: [],
    request_channel_slug: [],
    response_channel_slug: [],
    messenger_number: [],
    linkedin_number: [],
    whatsapp_number: [],
    postal_address: [],
    claimer_expectation: [],
    description: [],
    amount_currency_slug: [],
    amount_disputed: [],
    claimer_id: [],
    event_occured_at: [],
    is_revival: [],
    received_at: [],
    prepaid_card_number: [],
    send_mail: [],
    file: [],
  };

  const option1 = 1;
  const option2 = 0;

  const [claimObject, setClaimObject] = useState(null);
  const [claimObjects, setClaimObjects] = useState([]);
  const [claimCategory, setClaimCategory] = useState(null);
  const [claimCategories, setClaimCategories] = useState([]);
  const [relationship, setRelationship] = useState(null);
  const [relationships, setRelationships] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [account, setAccount] = useState(null);
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState(null);
  const [responseChannels, setResponseChannels] = useState([]);
  const [channels, setChannels] = useState([]);
  const [responseChannel, setResponseChannel] = useState(null);
  const [receptionChannel, setReceptionChannel] = useState(null);
  const [currency, setCurrency] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const [disabledInput, setDisabledInput] = useState(true);
  const [disabledInputTel, setDisabledInputTel] = useState(false);
  const [disabledInputEmail, setDisabledInputEmail] = useState(false);
  const [institution, setInstitution] = useState(null);
  const [institutions, setInstitutions] = useState([]);
  const [error, setError] = useState(defaultError);
  const [startRequest, setStartRequest] = useState(false);
  const [foundData, setFoundData] = useState({});
  const [clientCash, setClientCash] = useState({
    searchInputValue: "",
    clients: [],
  });

  const [isClaimCategoryOther, setIsClaimCategoryOther] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [startSearch, setStartSearch] = useState(false);
  const [componentData, setComponentData] = useState(undefined);
  const [load, setLoad] = useState(true);
  let dataLabel = {
    lastname: componentData ? componentData.params.fr.nom.value : "",
    firstname: componentData ? componentData.params.fr.prenoms.value : "",
    sexe: componentData ? componentData.params.fr.sexe.value : "",
    telephone: componentData ? componentData.params.fr.telephone.value : "",
    email: componentData ? componentData.params.fr.email.value : "",
    ville: componentData ? componentData.params.fr.ville.value : "",
    lieu: componentData ? componentData.params.fr.lieu.value : "",
    unit_targeted_id: componentData ? componentData.params.fr.unite.value : "",
    account_number: componentData ? componentData.params.fr.compte.value : "",
    raison_sociale: componentData ? componentData.params.fr.raison_sociale.value : "",
    account_targeted_id: componentData
      ? componentData.params.fr.compte.value
      : "",
    relationship_id: componentData ? componentData.params.fr.date.value : "",
    claim_object_id: componentData ? componentData.params.fr.object.value : "",
    request_channel_slug: componentData
      ? componentData.params.fr.canal_reception.value
      : "",
    response_channel_slug: componentData
      ? componentData.params.fr.canal_reponse.value
      : "",
    messenger_number: componentData ? componentData.params.fr.messenger ? componentData.params.fr.messenger.value : t("Identifiant Messenger") : "",
    linkedin_number: componentData ? componentData.params.fr.linkedin ? componentData.params.fr.linkedin.value : t("Identifiant LinkedIn") : "",
    whatsapp_number: componentData ? componentData.params.fr.whatsapp ? componentData.params.fr.whatsapp.value : t("Contact WhatsApp") : "",
    postal_address: componentData ? componentData.params.fr.adresse ? componentData.params.fr.adresse.value : t("Adresse postale") : "",
    received_at: componentData ? componentData.params.fr.received_at ? componentData.params.fr.received_at.value : t("Date de réception de la demande") : "",
    amount_currency_slug: componentData
      ? componentData.params.fr.devise.value
      : "",
    claim_category: componentData
      ? componentData.params.fr.categorie.value
      : "",
    amount_disputed: componentData ? componentData.params.fr.montant.value : "",
    prepaid_card_number: t("Carte prépayée"),
    send_mail: t("Envoyer le récépissé ?"),
    event_occured_at: componentData ? componentData.params.fr.date.value : "",
    is_revival: componentData ? componentData.params.fr.question.value : "",
    description: componentData ? componentData.params.fr.description.value : "",
    claimer_expectation: componentData
      ? componentData.params.fr.attente.value
      : ""
  };

  const [tag, setTag] = useState({
    name: "",
    label: "",
    className: "",
    show: false,
  });

  const [completionError, setCompletionError] = useState({ ref: "", list: [] });

  const currentDate = new Date();
  currentDate.setHours(currentDate.getHours() + 1);

  const maxDate = currentDate
    .toISOString()
    .substr(0, currentDate.toISOString().length - 1);

  useEffect(() => {        
    if(claimCategory && claimCategory?.label?.toLowerCase() === "autre"){
      setIsClaimCategoryOther(true)
    }else{
      setIsClaimCategoryOther(false)
    }
  }, [claimCategory])

  useEffect(() => {
    async function fetchData() {
      setLoad(true);
      await axios
        .get(endPoint.create)
        .then((response) => {
          if (
            verifyPermission(
              props.userPermissions,
              "store-claim-without-client"
            )
          )
            setRelationships(
              formatSelectOption(response.data.relationships, "name", "fr")
            );
          if (
            verifyPermission(
              props.userPermissions,
              "store-claim-against-any-institution"
            ) ||
            verifyPermission(
              props.userPermissions,
              "store-claim-without-client"
            )
          )
            setInstitutions(
              formatSelectOption(response.data.institutions, "name", false)
            );
          if (
            verifyPermission(
              props.userPermissions,
              "store-claim-against-my-institution"
            )
          ) {
            setUnits(
              formatSelectOption(
                response.data.units || response.data.institutions,
                "name",
                verifyPermission(
                  props.userPermissions,
                  "store-claim-against-any-institution"
                )
                  ? false
                  : "fr"
              )
            );
          }
          setClaimCategories(
            formatSelectOption(response.data.claimCategories, "name", "fr")
          );
          setCurrencies(
            formatSelectOption(response.data.currencies, "name", "fr", "slug")
          );
          setChannels(
            formatSelectOption(response.data.channels, "name", "fr", "slug")
          );
          setResponseChannels(
            formatSelectOption(
              filterChannel(response.data.channels, RESPONSE_CHANNEL),
              "name",
              "fr",
              "slug"
            )
          );
        })
        .catch((error) => { });
      await axios
        .get(
          appConfig.apiDomaine + "/components/retrieve-by-name/register_claim"
        )
        .then((response) => {
          setComponentData(resolveComponentLocale(response.data));
        })
        .catch((error) => {
        })
        .finally(() => {
          setLoad(false);
        });
    }

    if (verifyTokenExpire()) {
      fetchData();
    }
  }, [endPoint.create, props.userPermissions]);

  const onChangeFirstName = (e) => {
    const newData = { ...data };
    newData.firstname = e.target.value;
    setData(newData);
  };

  const onChangeLastName = (e) => {
    const newData = { ...data };
    newData.lastname = e.target.value;
    setData(newData);
  };

  const onChangeSexe = (e) => {
    const newData = { ...data };
    newData.sexe = e.target.value;
    setData(newData);
  };

  const onChangeVille = (e) => {
    const newData = { ...data };
    newData.ville = e.target.value;
    setData(newData);
  };

  const onChangeRaisonSociale = (e) => {
    const newData = { ...data };
    newData.raison_sociale = e.target.value;
    setData(newData);
  };
  const onChangeCustomerType = (e) => {
    const newData = { ...data };
    newData.type_client = e.target.value;
    newData.firstname = "";
    newData.lastname = "";
    newData.sexe = "";
    newData.ville = "";
    newData.telephone = [];
    newData.email = [];
    newData.raison_sociale = "";
    setData(newData);
  };

  const onChangeTelephone = (tel) => {
    const newData = { ...data };
    newData.telephone = tel;
    setData(newData);
  };

  const onChangeEmail = (mail) => {
    const newData = { ...data };
    newData.email = mail;
    setData(newData);
  };

  const onChangeFile = (e) => {
    const newData = { ...data };
    newData.file = Object.values(e.target.files);
    setData(newData);
  };

  const onChangeInstitution = (selected) => {
    const newData = { ...data };
    if (selected) {
      setInstitution(selected);
      newData.institution_targeted_id = selected.value;
      if (
        !verifyPermission(props.userPermissions, "store-claim-without-client")
      ) {
        if (verifyTokenExpire()) {
          axios
            .get(
              `${appConfig.apiDomaine}/institutions/${selected.value}/clients`
            )
            .then((response) => {
              setUnits(formatSelectOption(response.data.units, "name", "fr"));
            })
            .catch((error) => { });
        }
      }
    } else {
      setUnits([]);
      setUnit(null);
      setInstitution(null);
      setAccount(null);
      setAccounts([]);
      newData.firstname = "";
      newData.lastname = "";
      newData.sexe = "";
      newData.telephone = [];
      newData.email = [];
      newData.ville = "";
      newData.raison_sociale = "";
      newData.type_client = "";
      newData.unit_targeted_id = "";
      newData.claimer_id = "";
      newData.account_targeted_id = "";
      newData.account_number = "";
      newData.institution_targeted_id = "";
    }
    setData(newData);
  };

  const handleDisabledInputChange = (e) => {
    setSearchList([]);
    setShowSearchResult(false);
    setSearchInputValue("");
    const newData = { ...data };
    setAccount(null);
    setAccounts([]);
    newData.firstname = "";
    newData.lastname = "";
    newData.sexe = "";
    newData.telephone = [];
    newData.email = [];
    newData.ville = "";
    newData.raison_sociale = "";
    newData.type_client = "";
    newData.claimer_id = "";
    newData.account_targeted_id = "";
    newData.account_number = "";
    setData(newData);
    setDisabledInput(e.target.checked);
    if (!e.target.checked) {
      setDisabledInputEmail(false);
      setDisabledInputTel(false);
    }
  };

  const onChangeUnit = (selected) => {
    const newData = { ...data };
    if (selected) {
      setUnit(selected);
      newData.unit_targeted_id = selected.value;
    } else {
      newData.unit_targeted_id = "";
      setUnit(null);
    }
    setData(newData);
  };

  const handleCustomerChange = (e, selected) => {
    const newData = { ...data };
    setAccount(null);
    newData.account_targeted_id = "";
    newData.account_number = "";
    setAccounts(formatSelectOption(selected.accounts, "number", false));
    newData.firstname = selected.identity.firstname;
    newData.lastname = selected.identity.lastname;
    newData.sexe = selected.identity.sexe;
    newData.telephone = selected.identity.telephone
      ? selected.identity.telephone
      : [];
    newData.email = selected.identity.email ? selected.identity.email : [];
    newData.ville = selected.identity.ville;
    newData.type_client = selected.identity.type_client;
    newData.raison_sociale = selected.identity.raison_sociale;
    newData.claimer_id = selected.identity.id;
    setShowSearchResult(false);
    setSearchList([]);
    setData(newData);

    if (
      selected.identity?.telephone &&
      Array.isArray(selected.identity.telephone) &&
      selected.identity.telephone.length > 0
    ) {
      setDisabledInputTel(true);
    }

    if (
      selected.identity?.email &&
      Array.isArray(selected.identity.email) &&
      selected.identity.email.length > 0
    ) {
      setDisabledInputEmail(true);
    }
  };

  const onChangeAccount = (selected) => {
    const newData = { ...data };
    if (selected) {
      setAccount(selected);
      newData.account_targeted_id = selected.value;
    } else {
      setAccount(null);
      newData.account_targeted_id = "";
    }
    setData(newData);
  };

  const onChangeAccountNumber = (e) => {
    const newData = { ...data };
    newData.account_number = e.target.value;
    setData(newData);
  };

  const onChangeClaimObject = (selected) => {
    const newData = { ...data };
    if (selected) {
      setClaimObject(selected);
      newData.claim_object_id = selected.value;
    } else {
      setClaimObject(null);
      newData.claim_object_id = "";
    }
    setData(newData);
  };

  const onChangeReceptionChannel = (selected) => {
    const newData = { ...data };
    if (selected) {
      setReceptionChannel(selected);
      newData.request_channel_slug = selected.value;
    } else {
      setReceptionChannel(null);
      newData.request_channel_slug = "";
    }
    setData(newData);
  };

  const onChangeResponseChannel = (selected) => {
    const newData = { ...data };
    if (selected) {
      setResponseChannel(selected);
      newData.response_channel_slug = selected.value;
    } else {
      setResponseChannel(null);
      newData.response_channel_slug = "";
    }
    setData(newData);
  };


  const onChangeMessengerNumber = (e) => {
    const newData = { ...data };
    newData.messenger_number = e.target.value;
    setData(newData);
  };

  const onChangeLinkedinNumber = (e) => {
    const newData = { ...data };
    newData.linkedin_number = e.target.value;
    setData(newData);
  };

  const onChangeWhatsappNumber = (e) => {
    const newData = { ...data };
    newData.whatsapp_number = e.target.value;
    setData(newData);
  };

  const onChangePostalAddress = (e) => {
    const newData = { ...data };
    newData.postal_address = e.target.value;
    setData(newData);
  };

  const onChangeClaimCategory = (selected) => {
    const newData = { ...data };
    if (selected) {
      // if(selected.label.toLowerCase() == "autre"){
      //   setIsClaimCategoryOther(true);
      // }else{
      //   setIsClaimCategoryOther(false);
      // }
      
      setClaimCategory(selected);
      if (verifyTokenExpire()) {
        axios
          .get(
            `${appConfig.apiDomaine}/claim-categories/${selected.value}/claim-objects`
          )
          .then((response) => {
            newData.claim_object_id = "";
            setClaimObject(null);
            const newClaimObjects = formatSelectOption(response.data.claimObjects, "name", "fr");
            setClaimObjects(newClaimObjects);
            if(selected.label.toLowerCase() == "autre"){
              onChangeClaimObject(newClaimObjects[0])
            }
          })
          .catch((error) => console.log("Something is wrong"));
      }
    } else {
      setClaimObjects([]);
      setClaimObject(null);
      setClaimCategory(null);
      newData.claim_object_id = "";
    }
    setData(newData);
  };

  const onChangeClaimerExpectation = (e) => {
    const newData = { ...data };
    newData.claimer_expectation = e.target.value;
    setData(newData);
  };

  const onChangeDescription = (e) => {
    const newData = { ...data };
    newData.description = e.target.value;
    setData(newData);
  };
  const formatPrepaidCardForInput = (rawValue) => {
    const digits = (rawValue || "").toString().replace(/\D/g, "").slice(0, 10);
    if (!digits) return "";

    const chars = [];
    for (let i = 0; i < 16; i++) {
      if (i < 6) {
        // 6 premiers chiffres saisis
        chars[i] = digits[i] || "";
      } else if (i < 12) {
        // 6 chiffres du milieu toujours masqués
        chars[i] = "*";
      } else {
        // 4 derniers chiffres saisis
        const idx = 6 + (i - 12);
        chars[i] = digits[idx] || "";
      }
    }

    const group1 = chars.slice(0, 4).join("");
    const group2 = chars.slice(4, 8).join("");
    const group3 = chars.slice(8, 12).join("");
    const group4 = chars.slice(12, 16).join("");

    return `${group1} ${group2} ${group3} ${group4}`.trimEnd();
  };

  const onChangePrepaidCard = (e) => {
    const newData = { ...data };
    const inputValue = e.target.value;

    const prevDigits = (data.prepaid_card_number || "")
      .toString()
      .replace(/\D/g, "")
      .slice(0, 10);
    let digits = inputValue.replace(/\D/g, "").slice(0, 10);

    // Cas où l'utilisateur efface uniquement des caractères non numériques
    // (espaces ou *) : on réduit alors manuellement le nombre de chiffres
    if (
      digits === prevDigits &&
      prevDigits.length > 0 &&
      inputValue.length < formatPrepaidCardForInput(prevDigits).length
    ) {
      digits = prevDigits.slice(0, -1);
    }

    newData.prepaid_card_number = digits;
    setData(newData);
  };

  const onChangeAmountDisputed = (e) => {
    const newData = { ...data };
    newData.amount_disputed = e.target.value;
    setData(newData);
  };

  const onChangeAmountCurrency = (selected) => {
    const newData = { ...data };
    if (selected) {
      setCurrency(selected);
      newData.amount_currency_slug = selected.value;
    } else {
      setCurrency(null);
      newData.amount_currency_slug = "";
    }
    setData(newData);
  };

  const onChangeRelationShip = (selected) => {
    const newData = { ...data };
    setRelationship(selected);
    newData.relationship_id = selected ? selected.value : null;
    setData(newData);
  };

  const onChangeLieu = (e) => {
    const newData = { ...data };
    newData.lieu = e.target.value;
    setData(newData);
  };

  const handleEventOccuredAt = (e) => {
    const newData = { ...data };
    if (new Date(e.target.value) >= new Date()) {
      ToastBottomEnd.fire(
        toastErrorMessageWithParameterConfig(t("Date invalide"))
      );
      newData.event_occured_at = "";
    } else newData.event_occured_at = e.target.value;
    setData(newData);
  };

  const handleReceivedAt = (e) => {
    const newData = { ...data };
    if (new Date(e.target.value) >= new Date()) {
      ToastBottomEnd.fire(
        toastErrorMessageWithParameterConfig(t("Date invalide"))
      );
      newData.received_at = "";
    } else newData.received_at = e.target.value;
    setData(newData);
  };
  const handleOptionChange = (e) => {
    const newData = { ...data };
    newData.is_revival = parseInt(e.target.value);
    setData(newData);
  };

  const handleSendMailChange = (e) => {
    const newData = { ...data };
    newData.send_mail = parseInt(e.target.value);
    setData(newData);
  };

  const resetFountData = () => {
    resetAllData();
    setFoundData({});
    setData(defaultData);
    setError(defaultError);
  };

  const closeModal = () => {
    setFoundData({});
  };

  const formatFormData = (newData) => {
    const formData = new FormData();
    formData.append("_method", "post");
    for (const key in newData) {
      if (key === "file") {
        for (let i = 0; i < newData.file.length; i++)
          formData.append("file[]", newData[key][i], newData[key][i].name);
      } else if (key === "telephone") {
        for (let i = 0; i < newData.telephone.length; i++)
          formData.append("telephone[]", newData[key][i]);
      } else if (key === "email") {
        for (let i = 0; i < newData.email.length; i++)
          formData.append("email[]", newData[key][i]);
      } else formData.set(key, newData[key]);
    }
    return formData;
  };
  const startSearchClient = async () => {
    setStartSearch(true);
    const value =
      props.plan === "PRO"
        ? props.currentUserInstitution
        : verifyPermission(
          props.userPermissions,
          "store-claim-against-my-institution"
        )
          ? props.currentUserInstitution
          : institution.value;
    if (searchInputValue === clientCash.searchInputValue) {
      setStartSearch(false);
      setSearchList(clientCash.clients);
    } else {
      setStartSearch(true);
      if (tag.name.length && tag.show) {
        if (tag.name === "full_name" && isNaN(searchInputValue)) {
          if (verifyTokenExpire()) {
            await axios
              .get(
                `${appConfig.apiDomaine}/search/institutions/${value}/clients?type=name_or_phone&r=${searchInputValue}`
              )
              .then(({ data }) => {
                setStartSearch(false);
                if (data.length) {
                  setClientCash({
                    searchInputValue: searchInputValue,
                    clients: data,
                  });
                }
                setSearchList(data);
                setShowSearchResult(true);
              })
              .catch(({ response }) => {
                setStartSearch(false);
              });
          }
        } else if (tag.name === "telephone" && !isNaN(searchInputValue)) {
          if (verifyTokenExpire()) {
            await axios
              .get(
                `${appConfig.apiDomaine}/search/institutions/${value}/clients?type=name_or_phone&r=${searchInputValue}`
              )
              .then(({ data }) => {
                setStartSearch(false);
                if (data.length) {
                  setClientCash({
                    searchInputValue: searchInputValue,
                    clients: data,
                  });
                }
                setSearchList(data);
                setShowSearchResult(true);
              })
              .catch(({ response }) => {
                setStartSearch(false);
              });
          }
        } else if (tag.name === "account_number") {
          if (verifyTokenExpire()) {
            await axios
              .get(
                `${appConfig.apiDomaine}/search/institutions/${value}/clients?type=account_number&r=${searchInputValue}`
              )
              .then(({ data }) => {
                setStartSearch(false);
                if (data.length) {
                  setClientCash({
                    searchInputValue: searchInputValue,
                    clients: data,
                  });
                }
                setSearchList(data);
                setShowSearchResult(true);
              })
              .catch(({ response }) => {
                setStartSearch(false);
              });
          }
        } else {
          setStartSearch(false);
          setSearchList([]);
        }
      } else {
        if (verifyTokenExpire()) {
          await axios
            .get(
              `${appConfig.apiDomaine}/search/institutions/${value}/clients?type=name_or_phone&r=${searchInputValue}`
            )
            .then(({ data }) => {
              setStartSearch(false);
              if (data.length) {
                setClientCash({
                  searchInputValue: searchInputValue,
                  clients: data,
                });
              }
              setSearchList(data);
              setShowSearchResult(true);
            })
            .catch(({ response }) => {
              setStartSearch(false);
            });
        }
      }
    }
  };

  const onClickTag = (name, label, className) => {
    const newTag = { ...tag };
    newTag.name = name;
    newTag.label = label;
    newTag.className = className;
    newTag.show = true;
    setTag(newTag);
  };

  const onCloseTag = () => {
    const newTag = { ...tag };
    newTag.name = "";
    newTag.label = "";
    newTag.className = "";
    newTag.show = false;
    setTag(newTag);
  };

  const searchClient = () => {
    if (searchInputValue.length) {
      if (
        verifyPermission(
          props.userPermissions,
          "store-claim-against-any-institution"
        )
      ) {
        if (institution) {
          startSearchClient();
        } else
          ToastBottomEnd.fire(
            toastErrorMessageWithParameterConfig(
              t("Veuillez sélectionner une institution")
            )
          );
      } else if (
        verifyPermission(
          props.userPermissions,
          "store-claim-against-my-institution"
        )
      ) {
        startSearchClient();
      }
    } else {
      ToastBottomEnd.fire(
        toastErrorMessageWithParameterConfig(
          t("Veuillez renseigner le champ de recherche")
        )
      );
    }
  };

  const resetAllData = async () => {
    await setDisabledInput(false);
    await setDisabledInputEmail(false);
    await setDisabledInputTel(false);
    document.getElementById("is_client").click();
    await setInstitution(null);
    await setClaimCategory(null);
    await setCurrency(null);
    await setResponseChannel(null);
    await setReceptionChannel(null);
    await setClaimObject(null);
    await setClaimObjects([]);
    await setAccounts([]);
    await setAccount(null);
    if (props.plan !== "PRO") {
      if (
        verifyPermission(
          props.userPermissions,
          "store-claim-against-my-institution"
        ) &&
        props.plan === "MACRO"
      ) {
      } else {
        await setUnits([]);
      }
    }
    await setUnit(null);
    await setData(defaultData);
    await setRelationship(null);
    setStartRequest(false);
    await setSearchInputValue("");
    await setError(defaultError);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const newData = { ...data };

    // Validation format carte prépayée :
    // on attend exactement 10 chiffres saisis :
    // 6 premiers chiffres + 4 derniers, les 6 du milieu seront masqués avant l'envoi au backend.
    if (data.prepaid_card_number) {
      const digits = data.prepaid_card_number.replace(/\D/g, "");
      if (digits.length !== 10) {
        setError({
          ...error,
          prepaid_card_number: [
            t(
              "Le format de la carte prépayée est invalide (10 chiffres requis : 6 premiers et 4 derniers)."
            ),
          ],
        });
        return;
      } else {
        const first6 = digits.slice(0, 6);
        const last4 = digits.slice(6);
        const maskedMiddle = "******";
        newData.prepaid_card_number = `${first6}${maskedMiddle}${last4}`;
      }
    }

    newData.event_occured_at = formatToTimeStamp(data.event_occured_at);
    newData.received_at = formatToTimeStamp(data.received_at);
    if (!newData.file.length) delete newData.file;
    if (!newData.response_channel_slug) delete newData.response_channel_slug;
    if (!newData.unit_targeted_id) delete newData.unit_targeted_id;
    if (!newData.account_targeted_id) delete newData.account_targeted_id;
    if (!newData.account_number) delete newData.account_number;

    if (!newData.prepaid_card_number) delete newData.prepaid_card_number;
    if (!newData.amount_disputed) delete newData.amount_disputed;
    if (!newData.amount_currency_slug) delete newData.amount_currency_slug;

    if (!newData.claimer_id) delete newData.claimer_id;
    if (props.plan !== "HUB") delete newData.relationship_id;
    let labelkeys = Object.keys(dataLabel);
    labelkeys = labelkeys.filter((l) =>
      Array.isArray(newData[l]) ? newData[l].length : newData[l]
    );
    if (labelkeys.length === 0) {
      Swal.fire(
        t("pas de donnée ?"),
        t("Aucun champ n'est renseigné"),
        "question"
      );
      return;
    }

    const formatDate = (date) => {
      return new Date(date).toLocaleString('fr-FR', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit', 
        hour: '2-digit', 
        minute: '2-digit', 
        hour12: true 
      })
    }

    MySwal.fire({
      title: `<strong>${t("Détails sur la réclamation")}</strong>`,
      icon: "info",
      width: "50%",
      html: `
        <div class="row" style="height:50vh; overflow-y:scroll; margin-bottom:00px" >
         ${labelkeys
          .map((dl) => {
            return `<div class=" ${(dl === "description" || dl === "claimer_expectation") &&
              `${newData[dl]}`.length > 500
              ? "col-12"
              : "col-6 "
              } mb-4   text-left"> <strong>${dataLabel[dl]}</strong>: ${Array.isArray(newData[dl])
                ? newData[dl].map((t, i) => `  ${t}`)
                : dl === "account_targeted_id" ? accounts.find((acc) => acc.value === newData[dl])?.label
                : dl === "institution_targeted_id"
                  ? institutions.find((ins) => ins.value === newData[dl])?.label
                  : dl === "claim_object_id"
                    ? claimObjects.find((ins) => ins.value === newData[dl])?.label
                    : dl === "claim_category"
                      ? claimObjects.find((ins) => ins.value === newData[dl])?.label
                      : dl === "unit_targeted_id"
                        ? units.find((ins) => ins.value === newData[dl])?.label
                        : dl === "is_revival" || dl === "send_mail"
                          ? newData[dl]
                            ? t("Oui")
                            : t("Non")
                          : dl === "event_occured_at"
                            ? formatDate(newData[dl])
                            : dl === "received_at"
                              ? formatDate(newData[dl])
                              : newData[dl]
              } </div>`;
          })
          .join("")}
        </div>
        `,
      showCloseButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      focusConfirm: false,
      confirmButtonText: t("Oui"),
      cancelButtonText: t("Annuler"),
    }).then((result) => {
      if (result.isConfirmed) {
        if (verifyTokenExpire()) {
          setStartRequest(true);
          axios
            .post(endPoint.store, formatFormData(newData))
            .then(async (response) => {
              setDisabledInput(false);
              ToastBottomEnd.fire(toastAddSuccessMessageConfig());
              await resetAllData();
              document.getElementById("customFile").value = "";
              if (response.data.errors.length > 0) {
                setCompletionError({
                  ref: response.data.claim.reference,
                  list: response.data.errors,
                });
              }else if(newData.send_mail == 0){//
                await downloadReceipt(response.data.claim.id);
              }
            })
            .catch(async (error) => {
              if (completionError.length)
                if (completionError.length)
                  setCompletionError({ ref: "", list: [] });
              if (error.response.data.code === 409) {
                //Existing entity claimer
                setFoundData(error.response.data.error);
                setStartRequest(false);
                await setError(defaultError);
                await document.getElementById("confirmSaveForm").click();
              } else {
                setStartRequest(false);
                let fileErrors = [];
                let i = 0;
                for (const key in error.response.data.error) {
                  if (key === `file.${i}`) {
                    fileErrors = [
                      ...fileErrors,
                      ...error.response.data.error[`file.${i}`],
                    ];
                    i++;
                  }
                }
                setError({
                  ...defaultError,
                  ...error.response.data.error,
                  file: fileErrors,
                  claim_category:
                    claimCategory === null
                      ? [t("Le champ claim_category est obligatoire.")]
                      : [],
                });
                ToastBottomEnd.fire(toastAddErrorMessageConfig());
              }
            });
        }
      }
    });
  };
  document.addEventListener(
    "click",
    function (e) {
      e = e || window.event;
      var target = e.target;
      if (target.getAttribute("searchClient") === null) {
        setShowSearchResult(false);
      }
    },
    false
  );

  return load || !ready ? (
    <Loader />
  ) : verifyPermission(
    props.userPermissions,
    "store-claim-against-any-institution"
  ) ||
    verifyPermission(
      props.userPermissions,
      "store-claim-against-my-institution"
    ) ||
    verifyPermission(props.userPermissions, "store-claim-without-client") ? (
    <div
      className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
      id="kt_content"
    >
      <div className="kt-subheader   kt-grid__item" id="kt_subheader">
        <div className="kt-container  kt-container--fluid ">
          <div className="kt-subheader__main">
            <h3 className="kt-subheader__title">{t("Processus")}</h3>
            <span className="kt-subheader__separator kt-hidden" />
            <div className="kt-subheader__breadcrumbs">
              <a href="#icone" className="kt-subheader__breadcrumbs-home">
                <i className="flaticon2-shelter" />
              </a>
              <span className="kt-subheader__breadcrumbs-separator" />
              <a
                href="#button"
                onClick={(e) => e.preventDefault()}
                className="kt-subheader__breadcrumbs-link"
                style={{ cursor: "text" }}
              >
                {t("Collecte")}
              </a>
              <span className="kt-subheader__separator kt-hidden" />
              <div className="kt-subheader__breadcrumbs">
                <a href="#icone" className="kt-subheader__breadcrumbs-home">
                  <i className="flaticon2-shelter" />
                </a>
                <span className="kt-subheader__breadcrumbs-separator" />
                <a
                  href="#button"
                  onClick={(e) => e.preventDefault()}
                  className="kt-subheader__breadcrumbs-link"
                  style={{ cursor: "text" }}
                >
                  {t("Enregistrement de réclamation")}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
        <InfirmationTable className="alert-warning"
          information={
            <strong>
              {componentData ? componentData.params.fr.info_page.value : ""}
            </strong>
          }
        />
        <div className="row">
          <div className="col">
            <div className="kt-portlet">
              <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                  <h3 className="kt-portlet__head-title">
                    {componentData ? componentData.params.fr.title.value : ""}
                  </h3>
                </div>

                <div className="kt-portlet__head-toolbar">
                  <div className="kt-portlet__head-wrapper">
                    &nbsp;
                    <div className="dropdown dropdown-inline">
                      <InfoFormatExcel />
                      <a
                        href={`${appConfig.apiDomaine}/download-excel/claims`}
                        download={true}
                        className="btn mr-1 btn-secondary"
                      >
                        {" "}
                        {componentData
                          ? componentData.params.fr.telecharger.value
                          : ""}
                      </a>
                      <NavLink
                        to={"/process/claims/import"}
                        className="btn ml-1 btn-primary"
                      >
                        {" "}
                        {componentData
                          ? componentData.params.fr.importer.value
                          : ""}
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>

              <div className="kt-form">
                <div className="kt-portlet__body">
                  {verifyPermission(
                    props.userPermissions,
                    "store-claim-against-any-institution"
                  ) ||
                    verifyPermission(
                      props.userPermissions,
                      "store-claim-without-client"
                    ) ? (
                    <div
                      className={
                        error.institution_targeted_id.length
                          ? "form-group row validated"
                          : "form-group row"
                      }
                    >
                      <label
                        className="col-xl-3 col-lg-3 col-form-label"
                        htmlFor="institution"
                      >
                        {componentData
                          ? componentData.params.fr.institution.value
                          : ""}
                        <InputRequire />
                      </label>
                      <div className="col-lg-9 col-xl-6">
                        <Select
                          isClearable
                          value={institution}
                          placeholder={
                            componentData
                              ? componentData.params.fr.institution_placeholder
                                .value
                              : ""
                          }
                          onChange={onChangeInstitution}
                          options={institutions}
                        />
                        {error.institution_targeted_id.length
                          ? error.institution_targeted_id.map(
                            (error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            )
                          )
                          : null}
                      </div>
                    </div>
                  ) : null}

                  <div className="kt-section">
                    <div className="kt-section__body">
                      <h3 className="kt-section__title kt-section__title-lg">
                        {" "}
                        {componentData
                          ? componentData.params.fr.info_cible.value
                          : ""}
                      </h3>

                      {!verifyPermission(
                        props.userPermissions,
                        "store-claim-without-client"
                      ) ? (
                        <div className="form-group row d-flex flex-row-reverse">
                          <div className={"col d-flex align-items-center mt-4 ml-5"}>
                            <span className="mr-3">
                             {t("Le client est-il déjà enregistré")} ?
                            </span>
                            
                            <span className="kt-switch kt-switch--outline kt-switch--icon kt-switch--brand">
                             <label className="mb-0">
                               <input
                                id="is_client"
                                type="checkbox"
                                checked={disabledInput}
                                onChange={handleDisabledInputChange}
                               />
                               <span></span>
                              </label>
                            </span>

                             
                            <span className="ml-3 font-weight-bold">
                              {disabledInput ? t("Oui") : t("Non")}
                            </span>
                          </div>

                          <div className={"col"}>
                            <div
                              className="row"
                              onFocus={(e) => setShowSearchResult(true)}
                            >
                              <div className="col d-flex">
                                {tag.show && tag.name.length ? (
                                  <span
                                    className={"btn btn-label-" + tag.className}
                                    style={{
                                      marginTop: "2rem",
                                      borderBottomRightRadius: "0px",
                                      borderTopRightRadius: "0px",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <div>
                                      {tag.label}
                                      <button
                                        type="button"
                                        onClick={(e) => onCloseTag()}
                                        className="btn btn-icon"
                                        style={{
                                          height: "50%",
                                          width: "20%",
                                        }}
                                      >
                                        <i
                                          className="flaticon2-cross"
                                          style={{
                                            fontSize: "0.8em",
                                          }}
                                        />
                                      </button>
                                    </div>
                                  </span>
                                ) : null}

                                <input
                                  style={{
                                    marginTop: "2rem",
                                    borderBottomRightRadius: "0px",
                                    borderTopRightRadius: "0px",
                                  }}
                                  type="text"
                                  value={searchInputValue}
                                  onChange={(e) =>
                                    setSearchInputValue(e.target.value)
                                  }
                                  placeholder={
                                    t("Rechercher un client") + "..."
                                  }
                                  className="form-control"
                                  searchClient="searchClient"
                                  disabled={!disabledInput}
                                />

                                <button
                                  style={{
                                    marginTop: "2rem",
                                    borderTopLeftRadius: "0px",
                                    borderBottomLeftRadius: "0px",
                                  }}
                                  type="button"
                                  className="btn btn-primary btn-icon"
                                  disabled={!disabledInput || startSearch}
                                  onClick={(e) => searchClient()}
                                  searchClient="searchClient"
                                >
                                  <i
                                    searchClient="searchClient"
                                    className="fa fa-search"
                                  />
                                </button>
                              </div>
                            </div>

                            {startSearch ? (
                              <div className="row">
                                <div
                                  className={
                                    showSearchResult
                                      ? `dropdown-menu show p-4`
                                      : `dropdown-menu`
                                  }
                                  aria-labelledby="dropdownMenuButton"
                                  x-placement="bottom-start"
                                  style={{
                                    width: "100%",
                                    position: "absolute",
                                    willChange: "transform",
                                    top: "33px",
                                    left: "0px",
                                    transform: "translate3d(0px, 38px, 0px)",
                                    zIndex: "1",
                                  }}
                                >
                                  <span className={"mt-5 mb-5"}>
                                    <Loader />
                                  </span>
                                </div>
                              </div>
                            ) : disabledInput ? (
                              searchList.length ? (
                                <div className="row">
                                  <div
                                    className={
                                      showSearchResult
                                        ? `dropdown-menu show`
                                        : `dropdown-menu`
                                    }
                                    aria-labelledby="dropdownMenuButton"
                                    x-placement="bottom-start"
                                    style={{
                                      width: "100%",
                                      position: "absolute",
                                      willChange: "transform",
                                      top: "33px",
                                      left: "0px",
                                      transform: "translate3d(0px, 38px, 0px)",
                                      zIndex: "1",
                                    }}
                                  >
                                    <span className="d-flex justify-content-center">
                                      <em>
                                        {"---" + t("Type de recherche") + "---"}
                                      </em>
                                    </span>
                                    <div className="d-flex justify-content-center mt-1 mb-1">
                                      <button
                                        className="btn btn-outline-dark"
                                        onClick={(e) =>
                                          onClickTag(
                                            "full_name",
                                            t("Nom/Prénom"),
                                            "dark"
                                          )
                                        }
                                      >
                                        {t("Nom/Prénom")}
                                      </button>
                                      &nbsp;
                                      <button
                                        className="btn btn-outline-dark"
                                        onClick={(e) =>
                                          onClickTag(
                                            "telephone",
                                            t("Numéro de téléphone"),
                                            "dark"
                                          )
                                        }
                                      >
                                        {t("Numéro de téléphone")}
                                      </button>
                                      &nbsp;
                                      <button
                                        className="btn btn-outline-dark"
                                        onClick={(e) =>
                                          onClickTag(
                                            "account_number",
                                            t("Numéro de compte"),
                                            "dark"
                                          )
                                        }
                                      >
                                        {t("Numéro de compte")}
                                      </button>
                                    </div>
                                    <span className="d-flex justify-content-center mb-2">
                                      <em>{"---" + t("Fin") + "---"}</em>
                                    </span>
                                    {searchList.map((el, index) => (
                                      <span
                                        onClick={(e) =>
                                          handleCustomerChange(e, el)
                                        }
                                        key={index}
                                        className="dropdown-item"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <strong>{el.fullName}</strong>
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              ) : (
                                <div className="row">
                                  <div
                                    className={
                                      showSearchResult
                                        ? `dropdown-menu show p-4`
                                        : `dropdown-menu`
                                    }
                                    aria-labelledby="dropdownMenuButton"
                                    x-placement="bottom-start"
                                    style={{
                                      width: "100%",
                                      position: "absolute",
                                      willChange: "transform",
                                      top: "33px",
                                      left: "0px",
                                      transform: "translate3d(0px, 38px, 0px)",
                                      zIndex: "1",
                                    }}
                                  >
                                    {startSearch ? (
                                      <span className={"mt-5 mb-5"}>
                                        <Loader />
                                      </span>
                                    ) : (
                                      <>
                                        <span className="d-flex justify-content-center">
                                          <em>
                                            {"--- " +
                                              t("Type de recherche") +
                                              " ---"}
                                          </em>
                                        </span>
                                        <div className="d-flex justify-content-center mt-1 mb-1">
                                          <button
                                            className="btn btn-outline-primary"
                                            onClick={(e) =>
                                              onClickTag(
                                                "full_name",
                                                t("Nom/Prénom"),
                                                "primary"
                                              )
                                            }
                                          >
                                            {t("Nom/Prénom")}
                                          </button>
                                          &nbsp;
                                          <button
                                            className="btn btn-outline-primary"
                                            onClick={(e) =>
                                              onClickTag(
                                                "telephone",
                                                t("Numéro de téléphone"),
                                                "primary"
                                              )
                                            }
                                          >
                                            {t("Numéro de téléphone")}
                                          </button>
                                          &nbsp;
                                          <button
                                            className="btn btn-outline-primary"
                                            onClick={(e) =>
                                              onClickTag(
                                                "account_number",
                                                t("Numéro de compte"),
                                                "primary"
                                              )
                                            }
                                          >
                                            {t("Numéro de compte")}
                                          </button>
                                        </div>
                                        <span className="d-flex justify-content-center mb-2">
                                          <em>{"--- " + t("Fin") + " ---"}</em>
                                        </span>
                                        <span className="d-flex justify-content-center">
                                          <strong>
                                            {t("Pas de resultat")}
                                          </strong>
                                        </span>
                                      </>
                                    )}
                                  </div>
                                </div>
                              )
                            ) : null}
                          </div>
                        </div>
                      ) : null}

                      {/* Start Type Client */}
                      <div className="form-group row">
                        <div
                          className={
                            error.type_client.length
                              ? "form-group col-sm-12 col-xs-12 validated"
                              : "form-group col-sm-12 col-xs-12"
                          }
                        >
                          <label htmlFor="customer-type">
                            {/* {componentData
                              ? componentData.params.fr.sexe.value
                              : ""} */}
                            {t("Type de client")}
                            <InputRequire />
                          </label>
                          <select
                            disabled={disabledInput}
                            id="customer-type"
                            className={
                              error.type_client.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            value={data.type_client}
                            onChange={(e) => onChangeCustomerType(e)}
                          >
                            <option value="" disabled={true}>
                              {/* {componentData
                                ? componentData.params.fr.sexe_placeholder.value
                                : ""} */}
                              {t("Veuillez sélectionner le type")}
                            </option>

                            <option value="Physique">
                              {t("Personne physique")}
                            </option>
                            <option value="Moral">
                              {t("Personne morale")}
                            </option>
                          </select>
                          {error.type_client.length
                            ? error.type_client.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>
                      {/* End Type Client */}

                      {data?.type_client == "Moral" && (
                        <div className="form-group row">
                          <div
                            className={
                              error.raison_sociale.length
                                ? "col validated"
                                : "col"
                            }
                          >
                            <label htmlFor="raison_sociale">
                              {/* {componentData
                              ? componentData.params.fr.nom.value
                              : ""} */}
                              {dataLabel.raison_sociale}
                              <InputRequire />
                            </label>
                            <input
                              disabled={disabledInput}
                              id="raison_sociale"
                              type="text"
                              className={
                                error.raison_sociale.length
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder={
                                "Veuillez entrer le nom de l'entreprise"
                                // componentData
                                //   ? componentData.params.fr.nom_placeholder.value
                                //   : ""
                              }
                              value={data.raison_sociale}
                              onChange={(e) => onChangeRaisonSociale(e)}
                            />
                            {error.raison_sociale.length
                              ? error.raison_sociale.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>

                          <div
                            className={
                              error.ville.length ? "col validated" : "col"
                            }
                          >
                            <label htmlFor="ville">
                              {componentData
                                ? componentData.params.fr.ville.value
                                : ""}
                            </label>
                            <input
                              disabled={disabledInput}
                              id="ville"
                              type="text"
                              className={
                                error.ville.length
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder={
                                componentData
                                  ? componentData.params.fr.ville_placeholder
                                    .value
                                  : ""
                              }
                              value={data.ville ? data.ville : ""}
                              onChange={(e) => onChangeVille(e)}
                            />
                            {error.ville.length
                              ? error.ville.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>
                        </div>
                      )}

                      {data?.type_client == "Physique" && (
                        <>
                          <div className="form-group row">
                            <div
                              className={
                                error.lastname.length ? "col validated" : "col"
                              }
                            >
                              <label htmlFor="lastname">
                                {componentData
                                  ? componentData.params.fr.nom.value
                                  : ""}
                                <InputRequire />
                              </label>
                              <input
                                disabled={disabledInput}
                                id="lastname"
                                type="text"
                                className={
                                  error.lastname.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  componentData
                                    ? componentData.params.fr.nom_placeholder
                                      .value
                                    : ""
                                }
                                value={data.lastname}
                                onChange={(e) => onChangeLastName(e)}
                              />
                              {error.lastname.length
                                ? error.lastname.map((error, index) => (
                                  <div
                                    key={index}
                                    className="invalid-feedback"
                                  >
                                    {error}
                                  </div>
                                ))
                                : null}
                            </div>

                            <div
                              className={
                                error.firstname.length ? "col validated" : "col"
                              }
                            >
                              <label htmlFor="firstname">
                                {componentData
                                  ? componentData.params.fr.prenoms.value
                                  : ""}
                                <InputRequire />
                              </label>
                              <input
                                disabled={disabledInput}
                                id="firstname"
                                type="text"
                                className={
                                  error.firstname.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  componentData
                                    ? componentData.params.fr
                                      .prenoms_placeholder.value
                                    : ""
                                }
                                value={data.firstname}
                                onChange={(e) => onChangeFirstName(e)}
                              />
                              {error.firstname.length
                                ? error.firstname.map((error, index) => (
                                  <div
                                    key={index}
                                    className="invalid-feedback"
                                  >
                                    {error}
                                  </div>
                                ))
                                : null}
                            </div>
                          </div>

                          <div className="form-group row">
                            <div
                              className={
                                error.sexe.length
                                  ? "form-group col validated"
                                  : "form-group col"
                              }
                            >
                              <label htmlFor="sexe">
                                {componentData
                                  ? componentData.params.fr.sexe.value
                                  : ""}
                                <InputRequire />
                              </label>
                              <select
                                disabled={disabledInput}
                                id="sexe"
                                className={
                                  error.sexe.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                value={data.sexe}
                                onChange={(e) => onChangeSexe(e)}
                              >
                                <option value="" disabled={true}>
                                  {componentData
                                    ? componentData.params.fr.sexe_placeholder
                                      .value
                                    : ""}
                                </option>

                                <option value="F">{t("Féminin")}</option>
                                <option value="M">{t("Masculin")}</option>
                                <option value="A">{t("Autres")}</option>
                              </select>
                              {error.sexe.length
                                ? error.sexe.map((error, index) => (
                                  <div
                                    key={index}
                                    className="invalid-feedback"
                                  >
                                    {error}
                                  </div>
                                ))
                                : null}
                            </div>
                            <div
                              className={
                                error.ville.length ? "col validated" : "col"
                              }
                            >
                              <label htmlFor="ville">
                                {componentData
                                  ? componentData.params.fr.ville.value
                                  : ""}
                              </label>
                              <input
                                disabled={disabledInput}
                                id="ville"
                                type="text"
                                className={
                                  error.ville.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  componentData
                                    ? componentData.params.fr.ville_placeholder
                                      .value
                                    : ""
                                }
                                value={data.ville ? data.ville : ""}
                                onChange={(e) => onChangeVille(e)}
                              />
                              {error.ville.length
                                ? error.ville.map((error, index) => (
                                  <div
                                    key={index}
                                    className="invalid-feedback"
                                  >
                                    {error}
                                  </div>
                                ))
                                : null}
                            </div>
                          </div>
                        </>
                      )}

                      {data?.type_client && (
                        <div className="form-group row">
                          <div
                            className={
                              error.telephone.length ? "col validated" : "col"
                            }
                          >
                            <label htmlFor="telephone">
                              {componentData
                                ? componentData.params.fr.telephone.value
                                : ""}
                              <WithoutCode />
                              {responseChannel &&
                                responseChannel.value === "sms" ? (
                                <InputRequire />
                              ) : null}
                            </label>
                            <TagsInput
                              disabled={disabledInputTel}
                              value={data.telephone}
                              onChange={onChangeTelephone}
                              inputProps={{
                                className: "react-tagsinput-input",
                                placeholder: componentData
                                  ? componentData.params.fr
                                    .telephone_placeholder.value
                                  : "",
                              }}
                            />
                            {error.telephone.length
                              ? error.telephone.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>

                          <div
                            className={
                              error.email.length ? "col validated" : "col"
                            }
                          >
                            <label htmlFor="email">
                              {" "}
                              {componentData
                                ? componentData.params.fr.email.value
                                : ""}{" "}
                              {responseChannel &&
                                responseChannel.value === "email" ? (
                                <InputRequire />
                              ) : null}
                            </label>
                            <TagsInput
                              disabled={disabledInputEmail}
                              value={data.email}
                              onChange={onChangeEmail}
                              inputProps={{
                                className: "react-tagsinput-input",
                                placeholder: componentData
                                  ? componentData.params.fr.email_placeholder
                                    .value
                                  : "",
                              }}
                            />
                            {error.email.length
                              ? error.email.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />

                  <div className="kt-section">
                    <div className="kt-section__body">
                      <h3 className="kt-section__title kt-section__title-lg">
                        {" "}
                        {componentData
                          ? componentData.params.fr.info_reclamation.value
                          : ""}
                      </h3>
                      {!verifyPermission(
                        props.userPermissions,
                        "store-claim-without-client"
                      ) ? (
                        <div className="form-group row">
                          <div
                            className={
                              error.unit_targeted_id.length
                                ? "col validated"
                                : "col"
                            }
                          >
                            <label htmlFor="unit">
                              {componentData
                                ? componentData.params.fr.unite.value
                                : ""}
                            </label>
                            <Select
                              value={unit}
                              isClearable
                              placeholder={
                                componentData
                                  ? componentData.params.fr.unite_placeholder
                                    .value
                                  : ""
                              }
                              onChange={onChangeUnit}
                              options={units}
                            />
                            {error.unit_targeted_id.length
                              ? error.unit_targeted_id.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>

                          <div
                            className={
                              error.account_targeted_id.length ||
                                error.account_number.length
                                ? "col validated"
                                : "col"
                            }
                          >
                            <label htmlFor="account">
                              {componentData
                                ? componentData.params.fr.compte.value
                                : ""}
                            </label>
                            {accounts.length ? (
                              <Select
                                isClearable
                                value={account}
                                placeholder={
                                  componentData
                                    ? componentData.params.fr.compte_placeholder
                                      .value
                                    : ""
                                }
                                onChange={onChangeAccount}
                                options={accounts}
                              />
                            ) : (
                              <input
                                id="account"
                                type="text"
                                className={
                                  error.account_number.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  "Veuillez entrer le numéro de compte"
                                }
                                value={
                                  data.account_number ? data.account_number : ""
                                }
                                onChange={(e) => onChangeAccountNumber(e)}
                              />
                            )}
                            {error.account_targeted_id.length
                              ? error.account_targeted_id.map(
                                (error, index) => (
                                  <div
                                    key={index}
                                    className="invalid-feedback"
                                  >
                                    {error}
                                  </div>
                                )
                              )
                              : null}
                            {error.account_number.length
                              ? error.account_number.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>
                        </div>
                      ) : null}

                      <div className="form-group row">
                        <div
                          className={
                            error.request_channel_slug.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="receptionChannel">
                            {componentData
                              ? componentData.params.fr.canal_reception.value
                              : ""}
                            <InputRequire />
                          </label>
                          <Select
                            isClearable
                            value={receptionChannel}
                            placeholder={
                              componentData
                                ? componentData.params.fr
                                  .canal_reception_placeholder.value
                                : ""
                            }
                            onChange={onChangeReceptionChannel}
                            options={channels}
                          />
                          {error.request_channel_slug.length
                            ? error.request_channel_slug.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>

                        <div
                          className={
                            error.response_channel_slug.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="responseChannel">
                            {componentData
                              ? componentData.params.fr.canal_reponse.value
                              : ""}
                            <InputRequire />
                          </label>
                          <Select
                            isClearable
                            placeholder={
                              componentData
                                ? componentData.params.fr
                                  .canal_reponse_placeholder.value
                                : ""
                            }
                            value={responseChannel}
                            onChange={onChangeResponseChannel}
                            options={responseChannels}
                          />
                          {error.response_channel_slug.length
                            ? error.response_channel_slug.map(
                              (error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              )
                            )
                            : null}
                        </div>
                      </div>

                      {
                        data && data?.response_channel_slug === "messenger" ? (
                          <div className="form-group row">
                            <div
                              className={
                                error.messenger_number.length
                                  ? "col validated"
                                  : "col"
                              }
                            >
                              <label htmlFor="messengerNumber">
                                {dataLabel.messenger_number}
                                <InputRequire />
                              </label>
                              <input
                                id="messengerNumber"
                                type="text"
                                className={
                                  error.messenger_number.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  dataLabel.messenger_number
                                }
                                value={
                                  data.messenger_number
                                    ? data.messenger_number
                                    : ""
                                }
                                onChange={(e) => onChangeMessengerNumber(e)}
                              />  
                              {error.messenger_number.length
                                ? error.messenger_number.map(
                                  (error, index) => (
                                    <div
                                      key={index}
                                      className="invalid-feedback"
                                    >
                                      {error}
                                    </div>
                                  )
                                )
                                : null}
                            </div>
                          </div>  
                        ) : (null)
                      }

                      {
                        data && data?.response_channel_slug === "whatsapp" ? (
                          <div className="form-group row">
                            <div
                              className={
                                error.whatsapp_number.length
                                  ? "col validated"
                                  : "col"
                              }
                            >
                              <label htmlFor="whatsappNumber">
                                {dataLabel.whatsapp_number}
                                <WithCode />
                                <InputRequire />
                              </label>
                              <input
                                id="whatsappNumber"
                                type="text"
                                className={
                                  error.whatsapp_number.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  dataLabel.whatsapp_number
                                }
                                value={
                                  data.whatsapp_number
                                    ? data.whatsapp_number
                                    : ""
                                }
                                onChange={(e) => onChangeWhatsappNumber(e)}
                              />  
                              {error.whatsapp_number.length
                                ? error.whatsapp_number.map(
                                  (error, index) => (
                                    <div
                                      key={index}
                                      className="invalid-feedback"
                                    >
                                      {error}
                                    </div>
                                  )
                                )
                                : null}
                            </div>
                          </div>  
                        ) : (null)
                      }

                      {
                        data && data?.response_channel_slug === "linkedin" ? (
                          <div className="form-group row">
                            <div
                              className={
                                error.linkedin_number.length
                                  ? "col validated"
                                  : "col"
                              }
                            >
                              <label htmlFor="linkedinNumber">
                                {dataLabel.linkedin_number}
                                <InputRequire />
                              </label>
                              <input
                                id="linkedinNumber"
                                type="text"
                                className={
                                  error.linkedin_number.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  dataLabel.linkedin_number
                                }
                                value={
                                  data.linkedin_number
                                    ? data.linkedin_number
                                    : ""
                                }
                                onChange={(e) => onChangeLinkedinNumber(e)}
                              />  
                              {error.linkedin_number.length
                                ? error.linkedin_number.map(
                                  (error, index) => (
                                    <div
                                      key={index}
                                      className="invalid-feedback"
                                    >
                                      {error} 
                                    </div>
                                  )
                                )
                                : null}
                            </div>
                          </div>  
                        ) : (null)
                      }

                      {
                        data && data?.response_channel_slug === "courrier" ? (
                          <div className="form-group row">
                            <div
                              className={
                                error.postal_address.length
                                  ? "col validated"
                                  : "col"
                              }
                            >
                              <label htmlFor="postalAddress">
                                {dataLabel.postal_address}
                                <InputRequire />
                              </label>
                              <input
                                id="postalAddress"
                                type="text"
                                className={
                                  error.postal_address.length
                                    ? "form-control is-invalid"
                                    : "form-control"
                                }
                                placeholder={
                                  dataLabel.postal_address
                                }
                                value={
                                  data.postal_address
                                    ? data.postal_address
                                    : ""
                                }
                                onChange={(e) => onChangePostalAddress(e)}
                              />  
                              {error.postal_address.length
                                ? error.postal_address.map(
                                  (error, index) => (
                                    <div
                                      key={index}
                                      className="invalid-feedback"
                                    >
                                      {error}
                                    </div>
                                  )
                                )
                                : null}
                            </div>
                          </div>  
                        ) : (null)
                      }
                        

                      <div className="form-group row">
                        <div
                          className={
                            error.claim_category.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="claimCtegory">
                            {componentData
                              ? componentData.params.fr.categorie.value
                              : ""}
                            <InputRequire />
                          </label>
                          <Select
                            isClearable
                            placeholder={
                              componentData
                                ? componentData.params.fr.categorie_placeholder
                                  .value
                                : ""
                            }
                            value={claimCategory}
                            onChange={onChangeClaimCategory}
                            options={claimCategories}
                          />
                          {error.claim_category.length
                            ? error.claim_category.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>

                        {!isClaimCategoryOther ? <div
                          className={
                            error.claim_object_id.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="claimObject">
                            {componentData
                              ? componentData.params.fr.object.value
                              : ""}
                            <InputRequire />
                          </label>
                          <Select
                            isClearable
                            placeholder={
                              componentData
                                ? componentData.params.fr.object_placeholder
                                  .value
                                : ""
                            }
                            value={claimObject}
                            onChange={onChangeClaimObject}
                            options={claimObjects}
                          />
                          {error.claim_object_id.length
                            ? error.claim_object_id.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div> : null}

                        <div
                          className={
                            error.lieu.length ? "col validated" : "col"
                          }
                        >
                          <label htmlFor="lieu">
                            {componentData
                              ? componentData.params.fr.lieu.value
                              : ""}
                          </label>
                          <input
                            type={"text"}
                            id="lieu"
                            className={
                              error.lieu.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              componentData
                                ? componentData.params.fr.lieu_placeholder.value
                                : ""
                            }
                            value={data.lieu}
                            onChange={(e) => onChangeLieu(e)}
                          />
                          {error.lieu.length
                            ? error.lieu.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>

                      <div className="form-group row">
                        <div
                          className={
                            error.amount_disputed.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="amount_claim">
                            {componentData
                              ? componentData.params.fr.montant.value
                              : ""}{" "}
                            (
                            <strong className="text-danger">
                              Laissez vide si pas de montant
                            </strong>
                            )
                          </label>
                          <input
                            type={"number"}
                            id="amount_claim"
                            min="0"
                            className={
                              error.amount_disputed.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              componentData
                                ? componentData.params.fr.montant_placeholder
                                  .value
                                : ""
                            }
                            value={data.amount_disputed}
                            onChange={(e) => onChangeAmountDisputed(e)}
                          />
                          {error.amount_disputed.length
                            ? error.amount_disputed.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>

                        <div
                          className={
                            error.amount_currency_slug.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="currency">
                            {componentData
                              ? componentData.params.fr.devise.value
                              : ""}
                          </label>
                          <Select
                            isClearable
                            placeholder={
                              componentData
                                ? componentData.params.fr.devise_placeholder
                                  .value
                                : ""
                            }
                            value={currency}
                            onChange={onChangeAmountCurrency}
                            options={currencies}
                          />
                          {error.amount_currency_slug.length
                            ? error.amount_currency_slug.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>

                      <div className="form-group row">
                        <div
                          className={
                            error.prepaid_card_number.length ? "col validated" : "col"
                          }
                        >
                          <label htmlFor="prepaid_card_number">
                            {t("Carte prépayée")}
                          </label>
                          <div className="input-group">
                            <div className="input-group-prepend">
                              <span className="input-group-text">
                                <i className="fa fa-credit-card" />
                              </span>
                            </div>
                            <input
                              type="text"
                              id="prepaid_card_number"
                              className={
                                error.prepaid_card_number.length
                                  ? "form-control is-invalid"
                                  : "form-control"
                              }
                              placeholder={t("Ex: 1234 56** **** 7890")}
                              value={formatPrepaidCardForInput(
                                data.prepaid_card_number
                              )}
                              onChange={onChangePrepaidCard}
                            />
                          </div>
                          {error.prepaid_card_number.length
                            ? error.prepaid_card_number.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                          <small className="form-text text-muted">
                            {t(
                              "Saisissez 10 chiffres : les 6 premiers et les 4 derniers ; les autres seront automatiquement masqués."
                            )}
                          </small>
                        </div>
                      </div>

                      <div className="form-group row">
                        <div
                          className={
                            error.event_occured_at.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="date">
                            {componentData
                              ? componentData.params.fr.date.value
                              : ""}
                            <InputRequire />
                          </label>
                          <input
                            type={"datetime-local"}
                            id="date"
                            className={
                              error.event_occured_at.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              componentData
                                ? componentData.params.fr.date_placeholder.value
                                : ""
                            }
                            value={data.event_occured_at}
                            max={maxDate}
                            onChange={(e) => handleEventOccuredAt(e)}
                          />
                          {error.event_occured_at.length
                            ? error.event_occured_at.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>

                        {verifyPermission(
                          props.userPermissions,
                          "store-claim-without-client"
                        ) ? (
                          <div
                            className={
                              error.relationship_id.length
                                ? "col validated"
                                : "col"
                            }
                          >
                            <label htmlFor="relationship">
                              {componentData
                                ? componentData.params.fr.relation.value
                                : ""}{" "}
                              {t("avec l'institution")}
                              <InputRequire />
                            </label>
                            <Select
                              isClearable
                              value={relationship}
                              placeholder={
                                componentData
                                  ? componentData.params.fr.relation_placeholder
                                    .value
                                  : ""
                              }
                              onChange={onChangeRelationShip}
                              options={relationships}
                            />
                            {error.relationship_id.length
                              ? error.relationship_id.map((error, index) => (
                                <div key={index} className="invalid-feedback">
                                  {error}
                                </div>
                              ))
                              : null}
                          </div>
                        ) : null}

                        <div className="col">
                          <label htmlFor="file">
                            {componentData
                              ? componentData.params.fr.piece.value
                              : ""}
                          </label>
                          <input
                            onChange={onChangeFile}
                            type="file"
                            className={
                              error.file.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            id="customFile"
                            multiple={true}
                          />
                          {error.file.length
                            ? error.file.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>
                      
                      <div className="form-group row">
                        <div
                          className={
                            error.received_at.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="date">
                            {t("Date de réception de la demande")}
                            <InputRequire />
                          </label>
                          <input
                            type={"datetime-local"}
                            id="date"
                            className={
                              error.received_at.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              dataLabel.received_at
                            }
                            value={data.received_at}
                            max={maxDate}
                            onChange={(e) => handleReceivedAt(e)}
                          />
                          {error.received_at.length
                            ? error.received_at.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>

                      <div className="form-group row">
                        <div
                          className={
                            error.description.length ? "col validated" : "col"
                          }
                        >
                          <label htmlFor="description">
                            {componentData
                              ? componentData.params.fr.description.value
                              : ""}
                            <InputRequire />
                          </label>
                          <textarea
                            rows="7"
                            id="description"
                            className={
                              error.description.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              componentData
                                ? componentData.params.fr
                                  .description_placeholder.value
                                : ""
                            }
                            value={data.description}
                            onChange={(e) => onChangeDescription(e)}
                          />
                          {error.description.length
                            ? error.description.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>

                        <div
                          className={
                            error.claimer_expectation.length
                              ? "col validated"
                              : "col"
                          }
                        >
                          <label htmlFor="claimer_expectation">
                            {componentData
                              ? componentData.params.fr.attente.value
                              : ""}
                          </label>
                          <textarea
                            rows="7"
                            id="claimer_expectation"
                            className={
                              error.claimer_expectation.length
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder={
                              componentData
                                ? componentData.params.fr.attente_placeholder
                                  .value
                                : ""
                            }
                            value={data.claimer_expectation}
                            onChange={(e) => onChangeClaimerExpectation(e)}
                          />
                          {error.claimer_expectation.length
                            ? error.claimer_expectation.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>

                      <div className="form-group row">

                        <div
                          className={
                            error.send_mail.length ? "col validated" : "col"
                          }
                        >
                          <label className="d-block">
                            {t("Envoyer le récépissé ?")}
                          </label>
                          <div className="kt-radio-inline mt-2">
                            <label className="kt-radio">
                              <input
                                type="radio"
                                value={1}
                                onChange={handleSendMailChange}
                                checked={data.send_mail === 1}
                              />{" "}
                              {t("Oui")}
                              <span />
                            </label>
                            <label className="kt-radio">
                              <input
                                type="radio"
                                value={0}
                                onChange={handleSendMailChange}
                                checked={data.send_mail === 0}
                              />{" "}
                              {t("Non")}
                              <span />
                            </label>
                          </div>
                          {error.send_mail.length
                            ? error.send_mail.map((error, index) => (
                              <div key={index} className="invalid-feedback">
                                {error}
                              </div>
                            ))
                            : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="kt-separator kt-separator--border-dashed kt-separator--space-lg" />

                  <div className="kt-section">
                    <div className="kt-section__body">
                      <h3 className="kt-section__title kt-section__title-lg">
                        {componentData
                          ? componentData.params.fr.last_titre.value
                          : ""}
                        <InputRequire />
                      </h3>

                      <div className="form-group row">
                        <label className="col-3 col-form-label">
                          {componentData
                            ? componentData.params.fr.question.value
                            : ""}
                        </label>
                        <div className="col-9">
                          <div className="kt-radio-inline">
                            <label className="kt-radio">
                              <input
                                type="radio"
                                value={option1}
                                onChange={handleOptionChange}
                                checked={option1 == data.is_revival}
                              />{" "}
                              {componentData
                                ? componentData.params.fr.reponse_oui.value
                                : ""}
                              <span />
                            </label>
                            <label className="kt-radio">
                              <input
                                type="radio"
                                value={option2}
                                onChange={handleOptionChange}
                                checked={option2 == data.is_revival}
                              />{" "}
                              {componentData
                                ? componentData.params.fr.reponse_non.value
                                : ""}
                              <span />
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {completionError.list.length ? (
                    <div className="kt-section">
                      <div className="kt-section__body">
                        <div className="form-group row">
                          <div className="col-12">
                            <div
                              className="alert alert-warning fade show"
                              role="alert"
                            >
                              <div className="alert-icon">
                                <i className="flaticon-warning" />
                              </div>
                              <div className="alert-text">
                                <p>
                                  {t(
                                    "La réclamation a été enregistrée avec succès sous la référence "
                                  )}
                                  <strong>{completionError.ref}</strong>
                                </p>
                                <p>{t("Cependant elle est incomplète")}</p>
                                <p>
                                  {t(
                                    "Les informations qu'il reste à fournir sont les suivantes"
                                  )}{" "}
                                  :
                                </p>
                                <ul className="ml-4">
                                  {completionError.list.map((el, index) => (
                                    <li key={index}>
                                      - {localize(el.description)}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                              <div className="alert-close">
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="alert"
                                  aria-label={t("Close")}
                                >
                                  <span aria-hidden="true">
                                    <i className="la la-close" />
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="kt-portlet__foot">
                  <div className="kt-form__actions">
                    {!startRequest ? (
                      <button
                        type="submit"
                        onClick={(e) => onSubmit(e)}
                        className="btn btn-primary"
                      >
                        {t("Enregistrer")}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                        type="button"
                        disabled
                      >
                        {t("Chargement")}...
                      </button>
                    )}
                    <button
                      style={{ display: "none" }}
                      id="confirmSaveForm"
                      type="button"
                      className="btn btn-bold btn-label-brand btn-sm"
                      data-toggle="modal"
                      data-target="#kt_modal_4_2"
                    >
                      Launch Modal
                    </button>
                  </div>
                </div>
              </div>
              {foundData.entity ? (
                <ConfirmClaimAddModal
                  componentData={componentData ? componentData : undefined}
                  message={foundData.message ? foundData.message : ""}
                  id={foundData.entity.id}
                  firstname={
                    foundData.entity.firstname ? foundData.entity.firstname : ""
                  }
                  lastname={
                    foundData.entity.lastname ? foundData.entity.lastname : ""
                  }
                  sexe={foundData.entity.sexe ? foundData.entity.sexe : ""}
                  type_client={
                    foundData.entity.type_client
                      ? foundData.entity.type_client
                      : ""
                  }
                  telephone={
                    foundData.entity.telephone ? foundData.entity.telephone : []
                  }
                  email={foundData.entity.email ? foundData.entity.email : []}
                  ville={foundData.entity.ville ? foundData.entity.ville : ""}
                  raison_sociale={
                    foundData.entity.raison_sociale
                      ? foundData.entity.raison_sociale
                      : ""
                  }
                  lieu={data.lieu ? data.lieu : ""}
                  unit_targeted_id={
                    data.unit_targeted_id ? data.unit_targeted_id : ""
                  }
                  institution_targeted_id={
                    data.institution_targeted_id
                      ? data.institution_targeted_id
                      : ""
                  }
                  account_targeted_id={
                    data.account_targeted_id ? data.account_targeted_id : ""
                  }
                  account_number={
                    data.account_number ? data.account_number : ""
                  }
                  claim_object_id={
                    data.claim_object_id ? data.claim_object_id : ""
                  }
                  request_channel_slug={
                    data.request_channel_slug ? data.request_channel_slug : ""
                  }
                  response_channel_slug={
                    data.response_channel_slug ? data.response_channel_slug : ""
                  }
                  messenger_number ={
                    data.messenger_number ? data.messenger_number : ""
                  }
                  whatsapp_number={
                    data.whatsapp_number ? data.whatsapp_number : ""
                  }
                  linkedin_number={
                    data.linkedin_number ? data.linkedin_number : ""
                  }
                  postal_address={
                    data.postal_address ? data.postal_address : ""
                  }
                  claimer_expectation={
                    data.claimer_expectation ? data.claimer_expectation : ""
                  }
                  description={data.description ? data.description : ""}
                  amount_currency_slug={
                    data.amount_currency_slug ? data.amount_currency_slug : ""
                  }
                  amount_disputed={
                    data.amount_disputed ? data.amount_disputed : ""
                  }
                  claimer_id={data.claimer_id ? data.claimer_id : ""}
                  relationship_id={
                    data.relationship_id ? data.relationship_id : ""
                  }
                  event_occured_at={
                    data.event_occured_at ? data.event_occured_at : ""
                  }
                  received_at={
                    data.received_at ? data.received_at : ""
                  }
                  is_revival={data.is_revival ? data.is_revival : 0}
                  file={data.file ? data.file : []}
                  resetFoundData={resetFountData}
                  claimObject={claimObject ? claimObject : null}
                  claimObjects={claimObjects ? claimObjects : []}
                  claimCategory={claimCategory ? claimCategory : null}
                  claimCategories={claimCategories ? claimCategories : []}
                  accounts={accounts ? accounts : []}
                  account={account ? account : null}
                  units={units ? units : []}
                  unit={unit ? unit : null}
                  relationships={relationships ? relationships : []}
                  relationship={relationship ? relationship : null}
                  responseChannels={responseChannels ? responseChannels : []}
                  channels={channels ? channels : []}
                  responseChannel={responseChannel ? responseChannel : null}
                  receptionChannel={receptionChannel ? receptionChannel : null}
                  closeModal={closeModal}
                  currency={currency ? currency : null}
                  currencies={currencies ? currencies : []}
                  institution={institution ? institution : null}
                  institutions={institutions ? institutions : []}
                  endPoint={endPoint}
                  fileValue={document.getElementById("customFile").value}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
    currentUserInstitution: state.user.user.staff.institution_id,
  };
};

export default connect(mapStateToProps)(ClaimAdd);
